import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/shared/services/api.service';
import { CustomValidator } from 'src/app/shared/customvalidator/customvalidator';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  resetForm!: FormGroup;
  errorMessages: any;
  submitted = false;
  currentPageUrl: string = '';
  backendErrorMsg: any;
  token: any;

  constructor(private formBuilder: FormBuilder,
    public apiService: ApiService,
    private toastrService: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    public authService: AuthService) {
  }

  ngOnInit() {
    // Get token from URL
    this.token = this.route.snapshot.paramMap.get('token');
    if (!this.token) {
      this.router.navigate(['/']);  // Redirect to home or login if token is invalid
    }
    this.errorMessages = CustomValidator.ResetErrorMessages;
    this.initializeFormBuilder();
    this.currentPageUrl = window.location.origin;
  }
  initializeFormBuilder() {
    this.resetForm = this.formBuilder.group({
      newPassword: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(20), CustomValidator.alphanumericWithSpecialChar]],
      confirmPassword: ['', [Validators.required, Validators.maxLength(20)]]
    },
      {
        validator: CustomValidator.passwordConfirmPasswordMatchValidator // Apply the custom validator
      });
  }
  get resetFormGroupControls() {
    return this.resetForm?.controls;
  }
  logout() {
    this.authService.logout({ replaceUrl: true });
  }
  onSubmit() {
    this.submitted = true;
    //for success notification
    // this.toastrService.success('You have successfully updated your password.<br> Please login into your account using updated password.');
    // stop here if form is invalid
    if (this.resetForm.invalid) {
      return;
    }

    let apiUrlPath = environment.routes.RESET_PASSWORD;
    let payload = {
      "password": this.resetForm.get('newPassword')?.value,
      "token": this.token
      // "token": this.localStorageService.getItem('forgetPwdToken') // token generated in forgot password API
    }
    return this.apiService.post(apiUrlPath, payload).subscribe(response => {
      if (response?.status === 200) {
        //success response 
        // this.toastrService.success(response?.message);
        this.toastrService.success('You have successfully updated your password. Please login into your account using updated password.');
        this.logout();
      } else {
        this.backendErrorMsg = response?.message;
        this.toastrService.error(this.backendErrorMsg, '', { progressBar: true, progressAnimation: 'increasing' });
      }
    }, error => {
    });

  }

}
